// hooks/useLastUpdated.js
import { useQuery } from '@tanstack/react-query';
import apiService from '../../services/api';
import { ENDPOINTS } from '../../services/endpoints';

export const useLastUpdated = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['lastUpdated', 'timeData'],
    queryFn: async () => {
      const response = await apiService.get(ENDPOINTS.TIME_MAX_DATES);
      const maxUpdateDate = response?.max_date_updated;
      return maxUpdateDate ? new Date(maxUpdateDate).toISOString() : new Date().toISOString();
    },
    staleTime: 1000 * 60 * 10, // 10 minutes
    gcTime: 1000 * 60 * 60,    // 1 hour
    retry: 1,
  });

  return {
    lastUpdated: data,
    loading: isLoading,
    error: error?.message || null,
  };
};